
import { Vue } from 'vue-class-component'

export default class Home extends Vue {}
